import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions as trackingDataActions } from '../store';

interface AuthLayoutProps {
  children: React.ReactNode;
  trackingData?: any;
};

const LAZY_BGIMAGE_SCRIPT = `if("IntersectionObserver"in window){document.addEventListener("DOMContentLoaded",(function(){const e=document.querySelectorAll(".lazy-load-bgimage"),t=new IntersectionObserver((function(e){e.forEach((e=>{e.isIntersecting&&(e.target.style.backgroundImage="url('"+e.target.dataset.bgimage+"')",t.unobserve(e.target))}))}),{rootMargin:"100px"});e.forEach((e=>t.observe(e)))}));}else{document.querySelectorAll(".lazy-load-bgimage").forEach((e=>{e.style.backgroundImage="url('"+e.dataset.bgimage+"')"}))}`;

const Scripts = () => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: LAZY_BGIMAGE_SCRIPT,
      }}
    />
  )
}
/**
 * This is a pass-through component for handling Auth and Tracking Data and storing it in Redux
 * @param props 
 * @returns {JSX.Element}
 */
const AuthLayout = (props: AuthLayoutProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    //  Cookie data loaded into state
    dispatch(trackingDataActions.loadTrackingDataThunk());
  }, [dispatch]);
  
  const { children } = props;
  return <>{children}</>;  
};

export default AuthLayout;